"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getV2LoginCode = exports.getLoginToken = exports.getAccessToken = void 0;
var constants_1 = require("../constants");
var Axios_1 = require("../Axios");
var utils_1 = require("../utils");
var getTokenFetchRequestParams = function (config, apiParams, origin) {
    var authData = (0, utils_1.getStoredAuthData)();
    return {
        root_url: config.heimdallUrl,
        url: config.apiEndpoints.heimdallTokenFetch,
        method: constants_1.GET_METHOD,
        data: {
            user_id: apiParams.userId,
            usergroup_id: apiParams.usergroupId,
            access_token: (authData === null || authData === void 0 ? void 0 : authData.token) || '',
            source: origin,
        },
        withCredentials: true,
    };
};
var getLoginRequestParams = function (authCode, config) { return ({
    root_url: config.heimdallUrl,
    url: config.apiEndpoints.heimdallLogin,
    method: constants_1.GET_METHOD,
    data: { code: authCode },
    withCredentials: true,
}); };
var parseValueToInt = function (value) { return parseInt(value, 10); };
var getV2LoginRequestParams = function (config, apiParams, appUI) { return ({
    root_url: config.v2Url,
    url: config.apiEndpoints.v2Login,
    method: constants_1.GET_METHOD,
    withCredentials: true,
    data: {
        usersession: parseValueToInt(apiParams.userId),
        app: appUI || constants_1.APP_UI.DEFAULT,
    },
}); };
var getAccessToken = function (configHiver, config, apiParams, origin) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenFetchRequestParams, response, error_1;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 4, , 5]);
                if (!(!(0, utils_1.validateToken)(apiParams) || (0, utils_1.invalidateToken)(apiParams))) return [3, 2];
                console.log('HEIMDALL: No valid token, fetching token');
                tokenFetchRequestParams = getTokenFetchRequestParams(config, apiParams, origin);
                return [4, (0, Axios_1.performAxiosCall)(tokenFetchRequestParams)];
            case 1:
                response = _e.sent();
                return [2, {
                        atToken: (_a = response === null || response === void 0 ? void 0 : response.data.at) === null || _a === void 0 ? void 0 : _a.token,
                        expiryTime: (_b = response === null || response === void 0 ? void 0 : response.data.at) === null || _b === void 0 ? void 0 : _b.expires_at,
                        userId: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.user_id,
                        userGroupId: (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.usergroup_id,
                    }];
            case 2:
                console.log('Heimdall: Valid token already exists');
                return [2, {}];
            case 3: return [3, 5];
            case 4:
                error_1 = _e.sent();
                throw error_1;
            case 5: return [2];
        }
    });
}); };
exports.getAccessToken = getAccessToken;
var getLoginToken = function (authCode, configHiver, config) { return __awaiter(void 0, void 0, void 0, function () {
    var loginRequestParams, response, error_2;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                loginRequestParams = getLoginRequestParams(authCode, config);
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4, (0, Axios_1.performAxiosCall)(loginRequestParams)];
            case 2:
                response = _e.sent();
                return [2, {
                        userId: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.user_id,
                        userGroupId: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.usergroup_id,
                        atToken: (_c = response === null || response === void 0 ? void 0 : response.data.at) === null || _c === void 0 ? void 0 : _c.token,
                        expiryTime: (_d = response === null || response === void 0 ? void 0 : response.data.at) === null || _d === void 0 ? void 0 : _d.expires_at,
                    }];
            case 3:
                error_2 = _e.sent();
                throw error_2;
            case 4: return [2];
        }
    });
}); };
exports.getLoginToken = getLoginToken;
var getV2LoginCode = function (configHiver, config, apiParams, appUI) { return __awaiter(void 0, void 0, void 0, function () {
    var v2LoginRequestParams, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                console.log('ERROR debug: in getV2loginCode:', appUI);
                v2LoginRequestParams = getV2LoginRequestParams(config, apiParams, appUI);
                return [4, (0, Axios_1.performAxiosCall)(v2LoginRequestParams)];
            case 1:
                response = _a.sent();
                console.log('DEBUG HEIMDALL: local storage:', response === null || response === void 0 ? void 0 : response.data);
                return [2, response === null || response === void 0 ? void 0 : response.data.code];
            case 2:
                error_3 = _a.sent();
                throw error_3;
            case 3: return [2];
        }
    });
}); };
exports.getV2LoginCode = getV2LoginCode;
//# sourceMappingURL=index.js.map